import React, { Component, Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import AddPhotoIcon from '@material-ui/icons/AddPhotoAlternate';
import AddLocationIcon from '@material-ui/icons/Map';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import ShareIcon from '@material-ui/icons/Share';
import PreviewIcon from '@material-ui/icons/RemoveRedEye';
import ShoppingIcon from '@material-ui/icons/ShoppingCart';
import Avatar from '@material-ui/core/Avatar';
import { observer } from "mobx-react";
import moment from 'moment'
import QRCode from 'qrcode.react';
import environment from '../environments';
import 'react-trumbowyg/dist/trumbowyg.min.css'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Link } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../assets/css/react-datepicker.css";

const styles = theme => ({
  root: {
    width: '100%',
    padding: theme.spacing.unit * 3,
    backgroundColor: theme.palette.background.paper,
  },
  button: {
    fullWidth: true,
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  }
});

class StickerDetails extends Component {
  

  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleLandingpageInputChange = this.handleLandingpageInputChange.bind(this);
    this.handleLandingpageDateTimeChange = this.handleLandingpageDateTimeChange.bind(this);
    this.handleUnassign = this.handleUnassign.bind(this);
    this.handleUnassignModalClose = this.handleUnassignModalClose.bind(this);
    this.handleUnassignModalOpen = this.handleUnassignModalOpen.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.props.stickerStore.sticker[name] = value;
  }

  handleLandingpageInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    let newLandingpageValues = this.props.stickerStore.sticker.landingpageValues.map(function(item) {
      if (item.uuid === name) {
        item.inputvalue = value
      }
      return item
    })
    this.props.stickerStore.sticker.landingpageValues = newLandingpageValues;
  }

  handleLandingpageDateTimeChange(dateTime, uuid) {
    let newLandingpageValues = this.props.stickerStore.sticker.landingpageValues.map(function(item) {
      if (item.uuid === uuid) {
        item.inputvalue = moment(dateTime).toISOString()
      }
      return item
    })
    this.props.stickerStore.sticker.landingpageValues = newLandingpageValues;
  }

  handleSubmit(event) {
    this.props.stickerStore.saveSticker(this.props.match.params.id);
    event.preventDefault();
  }

  shareSticker() {
    /* this.props.stickerStore.shareSticker(this.props.match.params.id); */
  }

  zoomSticker() {
    //console.log("Sticker zoomed");
  }

  componentDidMount() {
    this.props.stickerStore.getSticker(this.props.match.params.id);
    //this.props.stickerStore.getStickerPhotos(this.props.match.params.id);
  }

  handleClose = () => {
    this.props.stickerStore.shareModalOpen = false;
  }

  handleDetailsClose = () => {
    this.props.stickerStore.detailsModalOpen = false;
  }

  handleDetailsOpen = () => {
    this.props.stickerStore.detailsModalOpen = true;
  }

  handleUnassign = () => {
    this.props.stickerStore.unassignSticker(this.props.match.params.id);
  }

  handleUnassignModalClose = () => {
    this.props.stickerStore.unassignModalOpen = false;
  }

  handleUnassignModalOpen = () => {
    this.props.stickerStore.unassignModalOpen = true;
  }

  handleShareSticker() {
    this.props.stickerStore.shareSticker(this.props.match.params.id);
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <Dialog
          open={this.props.stickerStore.shareModalOpen}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullScreen>
          <DialogTitle id="alert-dialog-title">{"Sticker teilen"}</DialogTitle>
          <DialogContent>
            <Grid container
            direction="row"
            justify="center"
            alignItems="center">
              <Grid item xs={12}>
                <Typography>
                  Diese Funktion ermöglicht es Ihnen, weitere Benutzer als Inhaber dieses Stickers hinzuzufügen.<br /><br />
                  Benutzer mit denen Sie den Sticker teilen, erhalten die folgenden Rechte:<br /><br />
                  - Lesen und Schreiben sämtlicher Einstellungen und Daten dieses Stickers<br />
                  - Hinzufügen weiterer Benutzer zu diesem Sticker<br />
                  - Vollständiges Löschen des Stickers<br />
                </Typography>
                  <hr />
                <Typography>
                  Wenn Sie damit einverstanden sind, lassen Sie den Benutzer, mit dem Sie den Sticker teilen möchten, den folgendne QR-Code mit der QRSticker App scannen.<br /><br />
                  <b>Dieser Vorgang kann nicht rückgängig gemacht werden</b>.
                </Typography>
                <hr />
              </Grid>
              <Grid item xs={12} style={{textAlign: "center"}}>
                <QRCode value={this.props.stickerStore.shareUrl} />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary" autoFocus>
              Schließen
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.props.stickerStore.detailsModalOpen}
          onClose={this.handleDetailsClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DialogTitle id="alert-dialog-title">{"Details zum Sticker"}</DialogTitle>
          <DialogContent style={{textAlign: 'center'}}>
            <QRCode value={environment.DELIVERY_HOST + "/" + this.props.stickerStore.sticker.identifier} />
            <Grid
              container
              direction="row"
              justify="flex-start"
              alignItems="flex-start">
                <Grid item xs={12} lg={12}>
                  <TextField
                    id="updated"
                    label="Zuletzt gescannt:"
                    fullWidth={true}
                    className={classes.textField}
                    value={this.props.stickerStore.sticker.scanned ? moment(this.props.stickerStore.sticker.scanned).format("DD.MM.YYYY, HH:mm") : 'Nie'}
                    margin="dense"
                    InputLabelProps={{shrink: true}}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} lg={12}>
                  <TextField
                    id="updated"
                    label="Zuletzt bearbeitet:"
                    fullWidth={true}
                    className={classes.textField}
                    value={this.props.stickerStore.sticker.updated ? moment(this.props.stickerStore.sticker.updated).format("DD.MM.YYYY, HH:mm") : 'Nie'}
                    margin="dense"
                    InputLabelProps={{shrink: true}}
                    disabled
                  />
                </Grid>
                <Grid item xs={12} lg={12}>
                  <TextField
                    id="granted"
                    label="Aktiviert:"
                    fullWidth={true}
                    className={classes.textField}
                    value={this.props.stickerStore.sticker.granted ? moment(this.props.stickerStore.sticker.granted).format("DD.MM.YYYY, HH:mm") : 'Nie'}
                    margin="dense"
                    InputLabelProps={{shrink: true}}
                    disabled
                  />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleDetailsClose} color="primary" autoFocus>
              Schließen
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.props.stickerStore.unassignModalOpen}
          onClose={this.handleUnassignModalClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DialogTitle id="alert-dialog-title">{"Sticker und QR-Code löschen"}</DialogTitle>
          <DialogContent>
            Bitte beachten Sie, dass der QR-Code <b>unwiderruflich gelöscht</b> wird.<br/>
            Eine erneute Aktivierung von Stickern mit diesem QR-Code ist <b>nicht möglich</b>. <br/>Bestehende Sticker mit diesem QR-Code werden durch den Löschvorgang <b>unbrauchbar</b>.<br/> Sämtliche mit dem Sticker verbundenen Informationen werden ebenfalls gelöscht.<br/>
            <br/>
            Möchten Sie den QR-Code mit der ID <b>{this.props.stickerStore.sticker.identifier}</b> wirklich löschen?
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleUnassign} color="secondary" autoFocus>
              Löschen
            </Button>
            <Button onClick={this.handleUnassignModalClose} color="primary" autoFocus>
              Abbrechen
            </Button>
          </DialogActions>
        </Dialog>
        <Grid container spacing={24}>
          <Grid item xs={12} lg={6}>
            <Typography variant="h6" gutterBottom>
              Einstellungen
            </Typography>
            <Grid container spacing={24}>
              <Grid item xs={6} lg={8}>
                <Grid
                container
                direction="row"
                justify="flex-start"
                alignItems="flex-end">
                  <Grid item xs={10} lg={10}>
                    <TextField
                      id="identifier"
                      name="identifier"
                      label="ID"
                      className={classes.textField}
                      value={this.props.stickerStore.sticker.identifier || ''}
                      onChange={this.handleInputChange}
                      margin="normal"
                      InputLabelProps={{shrink: true}}
                      disabled
                      fullWidth={true}
                    />
                  </Grid>
                  <Grid item xs={2} lg={2}>
                    <IconButton aria-label="QR-Code" style={{padding: 0, marginBottom: '8px', borderRadius: 0}} onClick={this.handleDetailsOpen}>
                      <Icon className="fa fa-qrcode" color="action" />
                    </IconButton>
                  </Grid>
                </Grid>
                <TextField
                  id="scans"
                  name="scans"
                  label="Anzahl Scans"
                  className={classes.textField}
                  value={this.props.stickerStore.sticker.scans || ''}
                  onChange={this.handleInputChange}
                  margin="normal"
                  InputLabelProps={{shrink: true}}
                  disabled
                  fullWidth={true}
                />
              </Grid>
              <Grid item xs={6} lg={4}>
                <Grid container
                  direction="row"
                  justify="flex-end"
                  alignItems="center">
                  <Grid item>
                  {this.props.stickerStore.sticker.photo_key ? (
                    <Link 
                      role="button"
                      to={{pathname: this.props.location.pathname + "/photos", state: {stickerId: this.props.match.params.id}}}> 
                      <Avatar src={environment.CDN_HOST + "/" + this.props.stickerStore.sticker.photo_key} style={{ borderRadius: 0, width: '128px', height: '128px' }} />
                    </Link>
                  ) : (
                    <Grid
                      container
                      direction="row"
                      justify="center"
                      alignItems="center"
                      style={{ width: '128px', height: '128px', backgroundColor: '#e0e0e0'}}>
                      <Grid item>
                        <Link 
                          role="button"
                          to={{pathname: this.props.location.pathname + "/photos", state: {stickerId: this.props.match.params.id}}}> 
                          <IconButton aria-label="Delete" className={classes.margin}>
                            <AddPhotoIcon fontSize="large" />
                          </IconButton>
                        </Link>
                      </Grid>
                    </Grid>
                  )}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} lg={12}>   
              <TextField
                  id="title"
                  name="title"
                  label="Stickername"
                  fullWidth={true}
                  className={classes.textField}
                  value={this.props.stickerStore.sticker.title || ''}
                  onChange={this.handleInputChange}
                  margin="normal"
                  InputLabelProps={{shrink: true}}
                />
                <br />
                <TextField
                  id="active"
                  name="active"
                  select
                  label="Sticker aktiv"
                  fullWidth={true}
                  className={classes.textField}
                  value={this.props.stickerStore.sticker.active || 0}
                  onChange={this.handleInputChange}
                  SelectProps={{
                    native: true,
                    MenuProps: {
                      className: classes.menu,
                    },
                  }}
                  margin="normal"
                  InputLabelProps={{shrink: true}}>
                  <option value="1">Ja</option>
                  <option value="0">Nein</option>
                </TextField>   
              </Grid>
            </Grid>
            {!!+this.props.stickerStore.sticker.active &&
            <Fragment>
            {!!+this.props.stickerStore.sticker.linkable &&
            <Fragment>
            <Typography variant="h6" style={{marginTop:"20px"}}>
              Zieladresse
            </Typography>
            <Grid container spacing={24}>
              <Grid item xs={12} lg={12}>
                <TextField
                    id="url"
                    name="url"
                    label={this.props.stickerStore.sticker.redirect_description || "Wohin soll Ihr Sticker weiterleiten?"}
                    fullWidth={true}
                    className={classes.textField}
                    value={this.props.stickerStore.sticker.url || ''}
                    onChange={this.handleInputChange}
                    margin="normal"
                    InputLabelProps={{shrink: true}}
                    placeholder="https://www.google.de"
                  />
              </Grid>
            </Grid>
            </Fragment>
            }
            {!!+this.props.stickerStore.sticker.landingpage &&
            <Fragment>
            <Typography variant="h6" style={{marginTop:"20px"}}>
              Startseite
            </Typography>
            <Grid container spacing={24}>
              <Grid item xs={12} lg={12}>
                <TextField
                  id="lp_active"
                  key="lp_active"
                  name="lp_active"
                  fullWidth={true}
                  select
                  label="Startseite des Stickers aktivieren?"
                  className={classes.textField}
                  value={this.props.stickerStore.sticker.lp_active || 0}
                  onChange={this.handleInputChange}
                  SelectProps={{
                    native: true,
                    MenuProps: {
                      className: classes.menu,
                    },
                  }}
                  margin="normal"
                  InputLabelProps={{shrink: true}}>
                  <option value="1">Ja</option>
                  <option value="0">Nein</option>
                </TextField>
                {(!!+this.props.stickerStore.sticker.lp_active) &&
                <Fragment>
                <Grid item xs={12} lg={12}>
                {this.props.stickerStore.sticker.landingpageInputs.map(function(item, index) {
                  switch(item.type) {
                    case 'text':
                      return (
                          <TextField
                            id={item.uuid}
                            key={item.uuid}
                            name={item.uuid}
                            label={item.label}
                            placeholder={item.placeholder}
                            type="text"
                            fullWidth={true}
                            className={classes.textField}
                            value={this.props.stickerStore.sticker.landingpageValues.filter(o => o.uuid === item.uuid)[0].inputvalue || ''}
                            onChange={this.handleLandingpageInputChange}
                            margin="normal"
                            InputLabelProps={{shrink: true}}
                          />
                      )
                    case 'text-multiline':
                        return (
                            <TextField
                              id={item.uuid}
                              key={item.uuid}
                              name={item.uuid}
                              label={item.label}
                              placeholder={item.placeholder}
                              type="text"
                              multiline
                              fullWidth={true}
                              className={classes.textField}
                              value={this.props.stickerStore.sticker.landingpageValues.filter(o => o.uuid === item.uuid)[0].inputvalue || ''}
                              onChange={this.handleLandingpageInputChange}
                              margin="normal"
                              InputLabelProps={{shrink: true}}
                            />
                      )
                    case 'number':
                      return (
                          <TextField
                            id={item.uuid}
                            key={item.uuid}
                            name={item.uuid}
                            label={item.label}
                            placeholder={item.placeholder}
                            type="number"
                            fullWidth={true}
                            className={classes.textField}
                            value={this.props.stickerStore.sticker.landingpageValues.filter(o => o.uuid === item.uuid)[0].inputvalue || ''}
                            onChange={this.handleLandingpageInputChange}
                            margin="normal"
                            InputLabelProps={{shrink: true}}
                          />
                      )
                    case 'email':
                      return (
                          <TextField
                            id={item.uuid}
                            key={item.uuid}
                            name={item.uuid}
                            label={item.label}
                            placeholder={item.placeholder}
                            type="email"
                            fullWidth={true}
                            className={classes.textField}
                            value={this.props.stickerStore.sticker.landingpageValues.filter(o => o.uuid === item.uuid)[0].inputvalue || ''}
                            onChange={this.handleLandingpageInputChange}
                            margin="normal"
                            InputLabelProps={{shrink: true}}
                          />
                      )
                    case 'phone':
                      return (
                          <TextField
                            id={item.uuid}
                            key={item.uuid}
                            name={item.uuid}
                            label={item.label}
                            placeholder={item.placeholder}
                            type="number"
                            fullWidth={true}
                            className={classes.textField}
                            value={this.props.stickerStore.sticker.landingpageValues.filter(o => o.uuid === item.uuid)[0].inputvalue || ''}
                            onChange={this.handleLandingpageInputChange}
                            margin="normal"
                            InputLabelProps={{shrink: true}}
                          />
                      )
                    case 'editor':
                      return <div key={item.uuid}>Editor</div>;
                    case 'dropdown':
                      return (
                          <TextField
                            id={item.uuid}
                            key={item.uuid}
                            name={item.uuid}
                            label={item.label}
                            placeholder={item.placeholder}
                            fullWidth={true}
                            className={classes.textField}
                            value={this.props.stickerStore.sticker.landingpageValues.filter(o => o.uuid === item.uuid)[0].inputvalue || ""}
                            onChange={this.handleLandingpageInputChange}
                            margin="normal"
                            InputLabelProps={{shrink: true}}
                            select
                            SelectProps={{
                              native: true,
                              MenuProps: {
                                className: classes.menu,
                              },
                            }}>
                              {(item.options !== null) ? (
                                JSON.parse(item.options).map(function(item, index) {
                                  return <option value={item} key={index}>{item}</option>
                                })
                              ) : (
                                <option disabled>-</option>
                              )}
                          </TextField>
                      )
                    case 'options':
                      return null
                    case 'date':
                      return (
                        <DatePicker
                          key={item.uuid}
                          selected={this.props.stickerStore.sticker.landingpageValues.filter(o => o.uuid === item.uuid)[0].inputvalue ? new Date(this.props.stickerStore.sticker.landingpageValues.filter(o => o.uuid === item.uuid)[0].inputvalue) : null}
                          onChange={(event) => this.handleLandingpageDateTimeChange(event, item.uuid)}
                          dateFormat="dd.MM.yyyy"
                          customInput={<TextField 
                            fullWidth={true} 
                            label={item.label} 
                            placeholder={item.placeholder} 
                            className={classes.textField} 
                            margin="normal" 
                            InputLabelProps={{shrink: true}}/>}
                        />
                      )
                    case 'time':
                      return (
                        <DatePicker
                          key={item.uuid}
                          selected={this.props.stickerStore.sticker.landingpageValues.filter(o => o.uuid === item.uuid)[0].inputvalue ? new Date(this.props.stickerStore.sticker.landingpageValues.filter(o => o.uuid === item.uuid)[0].inputvalue) : null}
                          onChange={(event) => this.handleLandingpageDateTimeChange(event, item.uuid)}
                          timeCaption={item.label} 
                          timeFormat="HH:mm"
                          dateFormat="HH:mm"
                          showTimeSelect
                          showTimeSelectOnly
                          customInput={<TextField 
                            fullWidth={true} 
                            label={item.label} 
                            placeholder={item.placeholder} 
                            className={classes.textField} 
                            margin="normal" 
                            InputLabelProps={{shrink: true}}/>}
                        />
                      )
                    case 'layout':
                      switch(item.html_element) {
                        case 'span':
                            return (<Typography key={item.uuid}>{item.label}</Typography>)
                        case 'h1':
                        case 'h2':
                        case 'h3':
                        case 'h4':
                        case 'h5':
                        case 'h6':
                          return (<Typography key={item.uuid} variant="h6" style={{marginTop:"20px", fontSize: "1.10rem"}}>{item.label}</Typography>)
                        default:
                          return null
                      }
                    default:
                      return <div key={item.uuid}>Default</div>;
                  }
                }, this)}
               </Grid>
               </Fragment>
               }
              </Grid>
            </Grid>
            </Fragment>
            }
            </Fragment>
            }
          </Grid>
        </Grid>
        <Grid container direction="column" spacing={24} style={{marginTop: "20px"}}>
          <Grid item xs={12} lg={6}>
            <Button variant="contained" color="secondary" fullWidth onClick={this.handleSubmit.bind(this)} className={classes.button}>
              Speichern
            </Button>
            {!!+this.props.stickerStore.sticker.location &&
            <Link 
              role="button"
              to={{pathname: this.props.location.pathname + "/location", state: {stickerId: this.props.match.params.id}}}> 
              <Button variant="contained" color="primary" fullWidth className={classes.button}>
                <AddLocationIcon className={classes.leftIcon}/>
                Standort
              </Button>
            </Link>
            }
            <Link 
              role="button"
              to={{pathname: this.props.location.pathname + "/photos", state: {stickerId: this.props.match.params.id}}}> 
              <Button variant="contained" color="primary" fullWidth className={classes.button}>
                <AddPhotoIcon className={classes.leftIcon}/>
                  Fotos
              </Button>
            </Link>
          </Grid>
          <Grid item xs={12} lg={6}>
            <Grid container direction="row" spacing={24}>
              {false &&
              <Grid item xs={6} lg={6}>
                <Button variant="contained" color="default" fullWidth onClick={this.handleShareSticker.bind(this)} className={classes.button}>
                  <ShareIcon className={classes.leftIcon}/>
                  Teilen
                </Button>
              </Grid>
              }
              <Grid item xs={12} lg={12}>
                <Button variant="contained" color="default" fullWidth onClick={()=> window.open(environment.DELIVERY_HOST + "/" + this.props.stickerStore.sticker.identifier + "?preview=1", "_blank")} className={classes.button}>
                  <PreviewIcon className={classes.leftIcon}/>
                  Vorschau
                </Button>
                {!!+this.props.stickerStore.sticker.shop_url_visible &&
                <Button variant="contained" color="default" fullWidth onClick={()=> window.open(this.props.stickerStore.sticker.shop_url)} className={classes.button}>
                  <ShoppingIcon className={classes.leftIcon}/>
                  Nachbestellen
                </Button>
                }
              </Grid>
              <Grid item xs={12} lg={12}>
                <Button color="secondary" fullWidth onClick={(this.handleUnassignModalOpen.bind(this))} className={classes.button}>
                  Sticker löschen
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        </div>
    );
  }
}

export default withStyles(styles)(observer(StickerDetails));
